import RestApiModel from "@/api/Model/RestApiModel";

class PrintIssueSystem extends RestApiModel {
  static getResourceEndpoint() {
    return '/facility-print-issue-systems';
  }
}

export default PrintIssueSystem;
